import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownItem } from '../../models/commonModel';
@Component({
  selector: 'app-licensetab',
  templateUrl: './licensetab.component.html',
  styleUrls: ['./licensetab.component.scss'],
})
export class LicensetabComponent implements OnInit {
  stateBoardLicensingText: string = `Applicant(s) company has an active license issued by the State Board for Licensing Contractors. This is not your local business license (see below). This could include a Contractors License (for projects $25,000 or more), a Home Improvement License (for projects less than $25,000), a Limited Licensed Electrician, or a Limited Licensed Plumber. If you are unsure if your business has one of the licenses, you can search https://verify.tn.gov/. If your business does not have a license from the State Board for Licensing Contractors, please ensure the check box is unchecked.`;
  countyBusiness: string = `If a county business license is not required by the county where the business entity was formed then choose Not Required from the County dropdown menu below.`;
  cityBusiness: string = `If a city business license is not required by the city where the business entity was formed then choose Not Required from the City dropdown menu below.`;

  @Input()
  LicenseTab!: FormGroup;
  allCountyTypes!: DropdownItem[];
  filterCountyTypes!: DropdownItem[];
  @Input() set CountyTypes(value: DropdownItem[]) {
    this.allCountyTypes = value;
    this.filterCountyTypes = value;
  }
  @Input()
  StateTypes!: DropdownItem[];
  allCityTypes!: DropdownItem[];
  filterCities!: DropdownItem[];
  @Input() set CityTypes(value: DropdownItem[]) {
    this.allCityTypes = value;
    this.filterCities = value;
  }

  constructor(private formBuilder: FormBuilder) {}
  onCountyKey(value: any) {
    this.filterCountyTypes = this.filterCounties(value);
    console.log(this.filterCities);
  }
  onKey(value: any) {
    this.filterCities = this.filterCity(value);
    console.log(this.filterCities);
  }

  filterCity(value: any) {
    let filter = value.target.value.toLowerCase();
    console.log(filter);
    if (filter.length > 0) {
      return this.filterCities.filter((option) =>
        option.name.toLowerCase().startsWith(filter)
      );
    } else {
      return this.allCityTypes;
    }
  }

  OnActiveStateCheck(){
    console.log("Check");
  }

  filterCounties(value: any) {
    let filter = value.target.value.toLowerCase();
    console.log(filter);
    if (filter.length > 0) {
      return this.filterCountyTypes.filter((option) =>
        option.name.toLowerCase().startsWith(filter)
      );
    } else {
      return this.allCountyTypes;
    }
  }
  ngOnInit(): void {
    
  }
}
